import type { ChipProps } from '@mui/material/Chip';
import { TimeAgo } from '../../time/timeAgo/TimeAgo';
import { FilledChip } from '../FilledChip';

interface Props extends Omit<ChipProps, 'label' | 'icon'> {
  date: Date | string;
  lang?: string;
}

export const DateChip = ({ date, lang = 'en', ...props }: Props) => {
  return (
    <FilledChip
      variant="filled"
      label={<TimeAgo date={date} lang={lang} />}
      {...props}
    />
  );
};
